import { render, staticRenderFns } from "./VRelated.vue?vue&type=template&id=16a54edb"
import script from "./VRelated.vue?vue&type=script&lang=js"
export * from "./VRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports